import './_account-register-form.scss';
import component from './account-register-form';

export default component;
